import Alert from './Alert';
import Button from './Button';
import Checkbox from './Checkbox';
import FormLabel from './FormLabel';
import Heading from './Heading';
import Icon from './Icon';
import Input from './Input';
import Radio from './Radio';
import { switchTheme } from './Switch';
import { tableTheme } from './Table';
import Tooltip from './Tooltip';

export default {
  Button,
  Heading,
  Table: tableTheme,
  Tooltip,
  Icon,
  Alert,
  Switch: switchTheme,
  Radio,
  FormLabel,
  Checkbox,
  Input,
};
